// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__374oO","tabsBox":"styles_tabsBox__1srmF","createButton":"styles_createButton__3cBtU"};